<app-nexus-loader *ngIf="showNexusLoader" [showLoader]="true" [autoHide]="true"
  (animationComplete)="showNexusLoader = false"></app-nexus-loader>

<div *ngIf="isLoading" class="spinner">
  <div class="lds-ring-xl"></div>
</div>
<div *ngIf="!isLoading">
  <router-outlet></router-outlet>
</div>
<app-global-modal></app-global-modal>
